// extracted by mini-css-extract-plugin
export default {"root":"zyMmXjtQ6whtNoqUtLVV","withVerticalMargin":"P5FWt5GnLz7_R3tDmyFf"};